import Breadcrumbs from '@mui/material/Breadcrumbs';
import Iconify from './Iconify';

export default function BasicBreadcrumb({ bread, ...other }) {
  return (
    <Breadcrumbs separator={<Iconify icon="eva:arrow-ios-forward-outline" />} aria-label="breadcrumb" {...other}>
      {bread}
    </Breadcrumbs>
  );
}
